import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const BOTPaymentOptionsBanner = ({
  paymentOptionsBannerContent
}) =>
  <Wrapper>
    <PaymentOptionsBannerContainer content={ paymentOptionsBannerContent } id="paymentOptionsBannerContainer" />
  </Wrapper>

export default BOTPaymentOptionsBanner

BOTPaymentOptionsBanner.propTypes = {
  paymentOptionsBannerContent: PropTypes.string
}

const PaymentOptionsBannerContainer = styled(HTMLContainer)`
  display: inline-block;
  ${Media.desktop`
    flex: 2;
   `}
  ${Media.mobile`
    margin: 16px;
  `}
`

const Wrapper = styled.div`
  margin: 0 auto;
  ${Media.desktop`
    display: flex;
  `}
`
